export default "__VITE_ASSET__k3l7S$qO__"